module.exports = __webpack_public_path__ + "soluti.png?710e8c0d21206d6a67fe3461e16d7b01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soluti.png
// module id = 66
// module chunks = 0